import { useQuery } from '@apollo/react-hooks';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import { withApollo } from '../../lib/apollo';
import User from './User';
import withNavWrapper from '../../hocs/NavWrapper';
import { USER_PROFILE } from '../../lib/queries/users';

const UserWithData = (props) => {
    const { currentUser } = props;

    const router = useRouter();
    const { user: preferredUsername } = router.query;

    React.useEffect(() => {
        window && window.scrollTo(0, 0);
    }, []);

    const { data, loading, networkStatus, error, refetch } = useQuery(USER_PROFILE, {
        notifyOnNetworkChange: true,
        variables: { preferredUsername },
    });

    const profile =
        data && data.profile
            ? {
                  ...data.profile,
              }
            : null;

    const isLoading = loading || networkStatus === 4;
    const isOwner =
        currentUser && profile
            ? currentUser.profile.preferredUsername === profile.preferredUsername
            : false;

    return (
        <User
            preferredUsername={preferredUsername}
            profile={profile}
            loading={isLoading}
            error={error}
            refetch={refetch}
            isOwner={isOwner}
        />
    );
};

UserWithData.propTypes = {
    classes: PropTypes.object.isRequired,
};

const DataProvidedComponent = withApollo(UserWithData);
const NavWrappedComponent = withNavWrapper(DataProvidedComponent);
export default NavWrappedComponent;
